import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";


import Header from "./components/Header";
import Feed from "./components/Feed";
import PageResults from "./components/PageResults";
import VideoDetails from "./components/VideoDetails";

import AppContext from "./context/AppContext";

const App = () => {
  return (
    <AppContext>
      <BrowserRouter>
        <div className="flex flex-col h-full  ">
          <Header />
          <Routes>
            <Route path="/" exact element={<Feed />} />
            <Route  path="/:pageQuery" element={<PageResults />}/>
            <Route path="/videos/:postId" element={<VideoDetails />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AppContext>
  );
};

export default App;
